const ContentTypes = {
    RichText: "OlympusRichText",
    PagePromotion: "OlympusPagePromotion",
    VueComponent: "OlympusVueComponent",
    SitesSetting: "SitesSetting"
};
export default {
    ...ContentTypes,
    GetId: (contentType) => {
        switch (contentType) {
            case ContentTypes.RichText: {
                return "5bacd68f-cfc3-11ec-8dab-afa427d3b1fb";
            }
            case ContentTypes.PagePromotion: {
                return "08fd87eb-fc86-11ec-8dab-afa427d3b1fb";
            }
            case ContentTypes.VueComponent: {
                return "8be9ab0f-cfa8-11ec-8dab-afa427d3b1fb";
            }
            case ContentTypes.SitesSetting: {
                return "52599618-0d8b-11e6-a13a-55e3718b665d";
            }
            default: {
                return null;
            }
        }
    }
};
